// extracted by mini-css-extract-plugin
export default {"wrapper":"LimitedTimeDiscountBanner_wrapper__xh6tM"};